<template>
    <div>
    <i :class="ico" @click="Switch()"></i>
    <input :type="type" @input="onInput" :class="active ? Style : 'login_input'" :placeholder="textpl">
    </div>
</template>

<script>
  export default {
    props: ['pattern', 'textpl', 'value','valid', 'active'],
    data() {
      return {
        activated: this.value != '',
        ico: 'icon-eye-off',
        type: 'password'
      };
    },
    computed: {
      Style() {
        if(this.valid)
        {
          return this.pattern.test(this.value) ? 'succes' : 'error';
        }
        else
        {
          return ''
        }
      }

    },
    methods: {
     onInput(e) {
        this.activated= true; 
        this.$emit('input', { activate: this.activated, completed: this.pattern.test(e.target.value), value: e.target.value });
      },

      Switch()
        {
          if (this.type == 'password')
           {
               this.type = 'text';
               this.ico = 'icon-eye';
           }
           else
           {
               this.type = 'password';
               this.ico = 'icon-eye-off';
           }
        }
     

    }
  };
</script>

<style lang="less" scoped>

div
{
    position: relative;
}

input[type="password"]
    {
        margin-top:12px;
        width: 356px;
        border-radius: 4px;
        background: none;
        border: solid 1px #718da8;
        padding: 18px 12px;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: left;
        color: #adc4e1;
        text-transform: uppercase;
        outline: none;
        box-sizing: border-box;

        &:hover
        {
            border: solid 1px #cae9ff;
        }

        &:focus
        {
            border: solid 1px #cae9ff;
        }
    }

input[type="text"]
{
    margin-top:12px;
    width: 356px;
    height: 48px;
    border-radius: 4px;
    line-height: normal;
    font-family: Arimo;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        color: #ffffff;
        background-color: #374b62;
        border: solid 1px #718da8;
        padding: 18px 12px;
        text-align: left;
        outline: none;

        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            opacity: 1; /* Firefox */
        }

        &::-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }

        &:hover
        {
            border: solid 1px #cae9ff;
        }

        &:focus
        {
            border: solid 1px #cae9ff;
        }
    }

i 
{
    cursor: pointer;
    display: block;
    text-align: right;
    position: absolute;
    font-size: 24px;
    color:#718da8;
    right: 13px;
    top:19px;

    &:hover
    {
        color:#fff;
    }
}

.error
{
    border: solid 1px #ff9292 !important; 
}

.succes
{
    border: solid 1px #00ffd0 !important; 
}

</style>